"use strict";
/** @module Survey-Taking Question Client */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var plugin_client_1 = __importDefault(require("@qualtrics/plugin-client"));
var window_1 = require("../../survey-taking-shared/src/window");
var defaultPostMessageTimeoutMs = 10000; // 10 seconds
var SurveyTakingQuestionClient = /** @class */ (function () {
    // The constructor must always be private! Use the initialize function, so that the necessary async initialization steps can happen.
    function SurveyTakingQuestionClient() {
        this._pluginClient = null; // Force TS to believe that the this will never be null, because the initialize function will guarantee it
        this._question = null; // Force TS to believe that the this will never be null, because the initialize function will guarantee it
        this._response = null; // Force TS to believe that the this will never be null, because the initialize function will guarantee it
        this._stateData = null; // Force TS to believe that the this will never be null, because the initialize function will guarantee it
        this._language = null; // Force TS to believe that the this will never be null, because the initialize function will guarantee it
        this._surveyId = null; // Force TS to believe that the this will never be null, because the initialize function will guarantee it
        this._surveyVersionId = null; // Force TS to believe that the this will never be null, because the initialize function will guarantee it
        this._sessionToken = null; // Force TS to believe that the this will never be null, because the initialize function will guarantee it
    }
    Object.defineProperty(SurveyTakingQuestionClient.prototype, "pluginClient", {
        get: function () {
            return this._pluginClient;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyTakingQuestionClient.prototype, "question", {
        get: function () {
            return this._question;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyTakingQuestionClient.prototype, "response", {
        get: function () {
            return this._response;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyTakingQuestionClient.prototype, "stateData", {
        get: function () {
            return this._stateData;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyTakingQuestionClient.prototype, "language", {
        get: function () {
            return this._language;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyTakingQuestionClient.prototype, "surveyId", {
        get: function () {
            return this._surveyId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyTakingQuestionClient.prototype, "surveyVersionId", {
        get: function () {
            return this._surveyVersionId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyTakingQuestionClient.prototype, "sessionToken", {
        get: function () {
            return this._sessionToken;
        },
        enumerable: false,
        configurable: true
    });
    SurveyTakingQuestionClient.initialize = function (config) {
        return __awaiter(this, void 0, void 0, function () {
            var clientInstance, handlers, _a, context, baseCssUrl, cssLink;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        clientInstance = new SurveyTakingQuestionClient();
                        handlers = clientInstance.getPluginClientHandler(config);
                        _a = clientInstance;
                        return [4 /*yield*/, plugin_client_1.default.initialize(handlers)];
                    case 1:
                        _a._pluginClient = _b.sent();
                        context = clientInstance.pluginClient.getContext();
                        return [4 /*yield*/, clientInstance.updatePluginStateDataObject(config.stateData)];
                    case 2:
                        _b.sent();
                        clientInstance._question = context.questionDef;
                        clientInstance._response = context.response;
                        clientInstance._language = context.language;
                        clientInstance._surveyId = context.surveyId;
                        clientInstance._surveyVersionId = context.surveyVersionId;
                        clientInstance._sessionToken = context.sessionToken;
                        baseCssUrl = context.questionDef.questionTypePluginProperties.BaseCssUrl;
                        cssLink = window_1.document.createElement('link');
                        cssLink.rel = 'stylesheet';
                        cssLink.href = baseCssUrl;
                        // Wait for the baseCssUrl to load, then return clientInstance after baseCssUrl is fully loaded, or exceptions thrown during loading baseCssUrl
                        return [2 /*return*/, new Promise(function (resolve) {
                                cssLink.onload = function () {
                                    resolve(clientInstance);
                                    clientInstance.loadPlugin();
                                };
                                cssLink.onerror = function () {
                                    resolve(clientInstance);
                                    clientInstance.loadPlugin();
                                };
                                window_1.document.head.appendChild(cssLink);
                            })];
                }
            });
        });
    };
    // Returns a set of handlers which the Survey Taking host can call to interact with the Survey Taking Question plugin
    SurveyTakingQuestionClient.prototype.getPluginClientHandler = function (config) {
        var _this = this;
        return {
            onHostHasChangedResponse: function (data, pluginClient) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    this._response = data.response;
                    (_b = (_a = config.handlers).onHostHasChangedResponse) === null || _b === void 0 ? void 0 : _b.call(_a, this._response);
                    return [2 /*return*/];
                });
            }); },
            onHostHasChangedPluginStateData: function (data, pluginClient) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    this._stateData = data.stateData;
                    (_b = (_a = config.handlers).onHostHasChangedPluginStateData) === null || _b === void 0 ? void 0 : _b.call(_a, this._stateData);
                    return [2 /*return*/];
                });
            }); },
        };
    };
    /**
     * Notifies the survey-taking host application that the plugin iframe has initialized
     * and that the question can be shown in place of the loading spinner
     */
    SurveyTakingQuestionClient.prototype.loadPlugin = function () {
        this.postMessage('onPluginHasLoaded', {});
    };
    /**
     * Retrieves localized strings from the Plugin's translation files, specifically
     * from the translation that matches the User's language. Valid keys are defined by top-level
     * properties of the `strings` object in the translation file.
     *
     * @param key The key for the text template to use
     * @param options.placeHolders (optional) - An object with values for any named placeholders in the template text
     * @param options.defaultVal (optional) - A default value to return if the key or translation doesn't exist
     * @returns the translation associated with the key
     */
    SurveyTakingQuestionClient.prototype.getText = function (key, options) {
        var _a = options || {}, placeHolders = _a.placeHolders, defaultVal = _a.defaultVal;
        return this.pluginClient.getText(key, placeHolders, defaultVal);
    };
    /**
     * Returns the language code of the logged in user given by the host on init.
     * @returns the language code of the logged user given by the host on init.
     */
    SurveyTakingQuestionClient.prototype.getLanguage = function () {
        return this.pluginClient.getLanguage();
    };
    SurveyTakingQuestionClient.prototype.postMessage = function (name_1, data_1) {
        return __awaiter(this, arguments, void 0, function (name, data, timeout) {
            var messageData;
            if (timeout === void 0) { timeout = defaultPostMessageTimeoutMs; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.pluginClient.postMessage(name, data, timeout)];
                    case 1:
                        messageData = _a.sent();
                        return [2 /*return*/, messageData];
                }
            });
        });
    };
    /**
     * Notifies the survey-taking host application of updated response data. Plugin
     * response data will be preserved by the survey-taking host through any navigation
     * event
     * @param response the updated response
     */
    SurveyTakingQuestionClient.prototype.updateResponse = function (response) {
        this.postMessage('onPluginHasChangedResponse', { response: response });
    };
    /**
     * Notifies the survey-taking host application of updated plugin state data. Plugin
     * state data will be dismissed by the survey-taking host on any navigation event.
     * @param stateData the updated state data object
     */
    SurveyTakingQuestionClient.prototype.updatePluginStateDataObject = function (stateData) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.postMessage('onPluginHasChangedStateData', { stateData: stateData })];
            });
        });
    };
    /**
     * Notifies the survey-taking host application of an update to the plugin state data.
     * A single field of the stateData object is updated and then the updated object is
     * passed to the survey-taking host application. Plugin state data will be dismissed
     * by the survey-taking host on any navigation event.
     * @param stateData the updated state data object
     * @param key key of the field to be updated
     * @param value new value for the field specified by the key
     */
    SurveyTakingQuestionClient.prototype.updatePluginStateDataField = function (stateData, key, value) {
        stateData[key] = value;
        this.postMessage('onPluginHasChangedStateData', { stateData: stateData });
    };
    /**
     * Notifies the survey-taking host application of an update to the plugin height
     * @param height the height in pixels
     */
    SurveyTakingQuestionClient.prototype.setContainerHeight = function (height) {
        this.postMessage('setContainerHeight', height);
    };
    /**
     * Invokes a predefined request configured for this question type.
     * @see {@link InvokePredefinedRequest}
     */
    SurveyTakingQuestionClient.prototype.invokePredefinedRequest = function (request, timeout) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postMessage('invokePredefinedRequestProxy', request, timeout)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    return SurveyTakingQuestionClient;
}());
exports.default = SurveyTakingQuestionClient;
//# sourceMappingURL=data:application/json;base64,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